import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../config/service";

export const couponApiService = createApi({
  reducerPath: "couponApiService",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    verifyCoupon: builder.mutation({
      query: (data) => {
        const token = JSON.parse(localStorage.getItem("token"));
        return {
          url: `/api/payment/v1/customer/checkout/validate/coupon`,
          method: "POST",
          headers: { "x-auth-token": token },
          data: data,
        };
      },
    }),
  }),
});

export const { useVerifyCouponMutation } = couponApiService;
